export const registrationTabMeta = {
  id: "registration",
  label: "ĐKMH",
  shortLabel: "ĐKMH",
};

export const previewRegistrationTabMeta = {
  id: "preview",
  label: "Preview",
  shortLabel: "Preview",
};
